/**
 * What it means for a quoted source to support, dispute or neither, in one place.
 *
 * Two readers are asked the same question about every quote a check keeps: the
 * check model, which labels each source's `stance` as it cites it, and the judge,
 * which reads the quote a second time (D106). The judge was given these words; the
 * check model was given "how this source bears on the claim", and nothing said what
 * support required. So across 76 real sources it counted a physical constant's
 * value, a database's page title and a conference's topic list as support, and the
 * judge, reading the quote against these words, called each one off-topic (D378).
 * Two readers with two definitions disagree about the definition as often as about
 * the quote; with one, a disagreement is a misreading by one of them (D379).
 *
 * The words are the judge's, unchanged, so its readings mean what they meant when
 * they were measured. No imports: both `engine/prompts.ts` and
 * `engine/judgeQuestions.ts` read this, and a module either loads at boot must not
 * pull the other in.
 */

/** The quoted words carry the claim. */
export const QUOTE_SUPPORTS =
  'The quoted words state, report or assume that the claim holds, or report a finding the claim follows from.'

/** The quoted words cut against the claim. */
export const QUOTE_DISPUTES =
  'The quoted words state the opposite of the claim, or report a measurement, result or fact the claim cannot survive.'

/** Everything else. The judge's `neither`; the check model's `context`. */
export const QUOTE_NEITHER =
  'The quoted words are about something else, are too indirect to bear on the claim either way, or describe the question without settling it.'
